<template>
  <div class="modal__fade" v-if="isOpenAnyModal"></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModalFade',
  computed: {
    ...mapGetters([
      'isOpenAnyModal'
    ])
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalFade.vue